import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { LogoRematchResultDto } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface RematchLogosParams {
  campaignId: string;
  /** The company that just left the library; omit after an addition. */
  removedCompanyId?: string;
}

export const rematchLogos = async (params: RematchLogosParams): Promise<LogoRematchResultDto> => {
  return await tinctApi.campaigns.rematchLogos(params.campaignId, {
    removedCompanyId: params.removedCompanyId,
  });
};

/**
 * Asks a campaign to re-match its customer logos against the current library.
 * Nothing is invalidated here: the rewrite runs in the returned job, so the
 * caller refreshes the pages once that job completes (see the studio's
 * `useLogoRematch`), not when the request returns. After a removal the
 * eviction itself is already reflected by `useDeleteBuyer`.
 */
export const useRematchLogos = (
  options?: Omit<UseMutationOptions<LogoRematchResultDto, ApiError, RematchLogosParams>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: rematchLogos,
    ...options,
  });
};
